// src/stores/rtcStore.js
import { create } from "zustand";

export const useRtcStore = create((set) => ({
  meetingStatusById: {}, // { [meetingId]: "approved" | "rejected" | ... }

  setMeetingStatus: (meetingId, status) =>
    set((state) => ({
      meetingStatusById: {
        ...state.meetingStatusById,
        [meetingId]: status,
      },
    })),
  
  activeCall: null, // { kind/id/mode/token/wsUrl/roomName/peerName/status }
  overlayOpen: false,

  setActiveCall: (call) => set({ activeCall: call }),
  clearActiveCall: () => set({ activeCall: null, overlayOpen: false }),

  openOverlay: () => set({ overlayOpen: true }),
  closeOverlay: () => set({ overlayOpen: false }),

  // callById: {}, // { [callId]: { status, mode } }
  // setCallStatus: (callId, status) =>
  //   set((s) => ({
  //     callById: {
  //       ...s.callById,
  //       [callId]: { ...(s.callById[callId] || {}), status },
  //     },
  //   })),
}));
